import React, { createContext, useState, useEffect, useContext, useCallback } from "react";
import axios from 'axios';


const BlogContext = createContext();

export const BlogProvider = ({ children }) => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isEmpty, setIsEmpty] = useState(false);

    const fetchBlogs = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            setIsEmpty(false);
            const apiUrl = process.env.REACT_APP_API_BASE_URL;

            const response = await axios.get(`${apiUrl}/security/getBlogs`);

            if (response.data?.success) {
                const blogData = response.data.data;

                if (!blogData || blogData.length === 0) {
                    setIsEmpty(true);
                }

                setBlogs(blogData || []);
            } else {
                setError("Unable to retrieve blog posts. Please try again later.");
            }
        } catch (error) {
            setError("We are experiencing technical difficulties. Please try again later.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchBlogs();
    }, [fetchBlogs]);

    const refreshBlogs = () => {
        fetchBlogs();
    };

    return (
        <BlogContext.Provider value={{
            blogs,
            loading,
            error,
            isEmpty,
            refreshBlogs
        }}>
            {children}
        </BlogContext.Provider>
    );
};

export const useBlogContext = () => {
    const context = useContext(BlogContext);
    if (!context) {
        throw new Error('useBlogContext must be used within a BlogProvider');
    }
    return context;
};
